import * as actionsType from "../actions/types";

const initialState = {
    isLoggedIn: false,
    user: {},
    RegisterUser: [],
    NumberRegisterUser: 0
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actionsType.LOGIN_SUCCESS:
            return { ...state, isLoggedIn: action.payload.data.success, user: action.payload.data.user };

        case actionsType.LOGOUT_SUCCESS:
            console.log("Initial State on logout", initialState)
            return { ...initialState };

        case actionsType.REGISTER:
            return { ...state };

        case actionsType.UPDATE_PROFILE:
            const { email, image, firstName, lastName, address, city, country, postalcode, phone } = action.payload
            const newState = state;
            newState.user.email = email;
            newState.user.image = image;
            newState.user.firstname = firstName;
            newState.user.lastname = lastName;
            newState.user.address = address;
            newState.user.city = city;
            newState.user.country = country;
            newState.user.zipcode = postalcode;
            newState.user.mobile = phone;


            return { ...state, newState };

        case actionsType.SET_REGISTERED_USER:
            // alert(JSON.stringify(action.payload))
            return { ...state, RegisterUser: [...action.payload.users], NumberRegisterUser: action.payload.size };

        case actionsType.DEL_REGISTERED_USER:
            // alert(JSON.stringify(action.payload))
            const { id } = action.payload;
            let index = state.RegisterUser.findIndex(i => i._id === id);
            state.RegisterUser.splice(index, 1)

            return { ...state, };

        case actionsType.UPDATE_USER_STATUS:
            const { regId, is_active } = action.payload;
            const updateState = state;
            if (updateState.user.is_active !== is_active)
                updateState.user.is_active = is_active;
            return { ...state, ...updateState };

        default:
            return state;
    }


}


